/** 사은품으로 취급하는 상품 태그 */
export const GIFT_TAGS = new Set(["Gift", "GWP"]);
